import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// layouts
import { AdminComponent } from "./layouts/admin/admin.component";
import { AppsComponent } from "./layouts/apps/apps.component";
import { AuthComponent } from "./layouts/auth/auth.component";

// admin views
import { DashboardComponent } from "./views/admin/dashboard/dashboard.component";
import { MapsComponent } from "./views/admin/maps/maps.component";
import { TablesComponent } from "./views/admin/tables/tables.component";

// auth views
import { LoginComponent } from "./views/auth/login/login.component";
import { RegisterComponent } from "./views/auth/register/register.component";

// apps views
import { NewsAnalyzerComponent } from "./views/apps/news-analyzer/news-analyzer.component";
import { TopicsAnalyzerComponent } from "./views/apps/topics-analyzer/topics-analyzer.component";

// no layouts views
import { IndexComponent } from "./views/index/index.component";
import { LandingComponent } from "./views/landing/landing.component";
import { ProfileComponent } from "./views/profile/profile.component";
import { ServiceDetailViewComponent } from "./views/service_detail_view/service_detail_view.component";
import { ServicesComponent } from "./views/services/services.component";
import { TextSummaryComponent } from "./views/apps/text-summary/text-summary.component";
import { ImageGenerationComponent } from "./views/apps/image-generation/image-generation.component";
import { NewsGenerationBaseballComponent } from "./views/apps/news-generation-baseball/news-generation-baseball.component";

const routes: Routes = [
  {
    path: "apps",
    component: AppsComponent,
    children: [
      { path: "news-analyzer", component: NewsAnalyzerComponent },
      { path: "topics-analyzer", component: TopicsAnalyzerComponent },
      { path: "text-summary", component: TextSummaryComponent },
      { path: "news-generation-baseball", component: NewsGenerationBaseballComponent },
      { path: "image-generation", component: ImageGenerationComponent },
      { path: "", redirectTo: "news-analyzer", pathMatch: "full" },
    ],
  },
  // admin views
  {
    path: "admin",
    component: AdminComponent,
    children: [
      { path: "dashboard", component: DashboardComponent },
      { path: "tables", component: TablesComponent },
      { path: "maps", component: MapsComponent },
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
    ],
  },
  // auth views
  {
    path: "auth",
    component: AuthComponent,
    children: [
      { path: "login", component: LoginComponent },
      { path: "register", component: RegisterComponent },
      { path: "", redirectTo: "login", pathMatch: "full" },
    ],
  },
  // no layout views
  { path: "profile", component: ProfileComponent },
  { path: "landing", component: LandingComponent },
  { path: "service/:id", component: ServiceDetailViewComponent },
  { path: "service", component: ServicesComponent },
  { path: "index", component: IndexComponent },
  { path: "", component: LandingComponent },
  { path: "**", redirectTo: "", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: "enabled"})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
